export const storeProducts = [
  {
    id: 1,
    title: "Samsung Galaxy Note 9",
    img: "img/product-1.png",
    price: 999.99,
    company: "SAMSUNG",
    info:
      "The Galaxy Note 9 is the best phone for business and continues to be my favorite phone of 2018. I've been using one now for several months and despite trying out some great new phones like the iPhone XS Max and Google Pixel 3 XL, none of these can replace the Note 9 and everything Samsung includes in this stunning device. This is especially true for use in the enterprise space. The Galaxy Note 9 improves upon the Note 8 with a Bluetooth S Pen, more internal capacity and RAM, a massive 4,000 mAh battery, better dual rear cameras with some software intelligence, enhanced audio capability, and new placement of the rear fingerprint scanner.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Huawei Mate 20 Pro",
    img: "img/product-2.png",
    price: 989.0,
    company: "HUAWEI",
    info:
      "Huawei recently announced the Mate 20 Pro and it brings together all of the greatness of Huawei into a single device that is tough to beat. The Mate 20 Pro includes the first Android 7nm process chipset with the Kirin 980 (Apple's A12 Bionic also uses the 7nm process), two Neural Processing Units, a fourth-generation image signal processor, and a LTE Cat.21 modem. The triple rear camera capability from the Huawei P20 Pro is brought to the Mate 20 Pro, but in a different central two-by-two arrangement with one change made to one of the three lenses. The three rear cameras have 40MP, 20MP, and 8MP resolution with a 24MP front-facing shooter and artificial intelligence to help you capture great shots. ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Google Pixel 3 XL",
    img: "img/product-3.png",
    price: 1029.99,
    company: "GOOGLE",
    info:
      "While the Galaxy Note 9 offers just about everything you want, software updates are not its specialty. If you want an Android phone that will always have the latest firmware and security updates, while also offering a fairly stock experience, then nothing beats the new Google Pixel 3 and 3 XL. These two phones are the exact same except for the overall size and battery capacity. The Google Pixel 3 XL has a large 6.3-inch 18:9 display, Snapdragon 845 processor, 4GB of RAM, 64GB and 128GB integrated storage, single rear 12.2 megapixel camera, dual front-facing cameras, IP68 dust and water resistance, a 3430 mAh battery, and dual front stereo speakers.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "iPhone XS Max",
    img: "img/product-4.png",
    price: 1199.0,
    company: "APPLE",
    info:
      "Apple pushed the entry-level price of a flagship up to $1,000 last year with the iPhone X and raised the bar again this year with the most expensive flagship available in the iPhone XS Max. ZDNet's Jason Cipriani awarded the iPhone XS Max an impressive near-perfect score of 9.6/10 so I'm pretty sure Jason would give the top spot to this phone. I ordered my own iPhone XS Max to replace my iPhone X, using the T-Mobile Jump On Demand program, but after two weeks I sent it back as I found the small size of the iPhone X was one of the primary reasons it still earned a place in my pocket. The Apple iPhone XS Max has been shown to best all other phones in benchmarking testing.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "OnePlus 6T",
    img: "img/product-5.png",
    price: 549.68,
    company: "ONEPLUS",
    info:
      "OnePlus launched the new OnePlus 6T at the end of October and for the first time ever it launched on a US wireless carrier. I picked up my Mirror Black model at a local T-Mobile store, after visiting several stores that were sold out, and took advantage of the $300 launch trade-in option. OnePlus earns a top five spot on my list because of the high end specifications, reasonable price that is hundreds less than other flagships, extremely responsive performance, and use of new technology. If I had an affordable smartphone list, then the OnePlus 6T would be number one with prices ranging from $549 to $629. ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Huawei P20 Pro",
    img: "img/product-6.png",
    price: 635.0,
    company: "HUAWEI",
    info:
      "While US consumers will have to resort to eBay to pick one up, the Huawei P20 Pro remains one of the most exciting phones, even with its new cousin just launching in the form of the Mate 20 Pro. The unique triple camera design with 68 megapixels worth of shooting power should help you take some fantastic shots with a low light mode that beats out all the other smartphones available today. Huawei has been including massive capacity batteries in its flagships and the P20 Pro is no exception with 4,000 mAh that is sure to get you through at least one full, busy day. It has a large 6.1 inch OLED with a notch you can show or hide, a powerful Kirin 970 processor with integrated AI, IP67 dust and water resistance, and more.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "iPhone XR",
    img: "img/product-7.png",
    price: 999.99,
    company: "APPLE",
    info:
      "This year Apple announced three new phones with one releasing a month after the other two. I traded in the iPhone XS Max for an iPhone XR and overall I am quite happy with the device and saving $350 over the iPhone XS Max. The Apple iPhone XR differs from the XS/XS Max with a LED screen instead of OLED, lower resolution, no 3D Touch support (does anyone even care about this?), a single rear camera, and a 6.1 inch display that fits in between these other two new phones. It has the same Apple A12 Bionic processor, same camera software and hardware as the 12MP prime camera, and other enhanced Apple features like face unlock. The iPhone XR has a larger capacity battery than the iPhone XS and a reported battery life greater than the XS and XS Max.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Sony Xperia XZ3",
    img: "img/product-9.png",
    price: 799.99,
    company: "SONY",
    info:
      "Sony is back on the 10 best list with its best smartphone in years in the form of the Xperia XZ3. I've been using one for a few weeks and even though I am not happy with the fingerprint scanner placement it is still a compelling smartphone. The Sony Xperia XZ3 matches up on the spec sheet closely with the Google Pixel 3 and 3 XL with 4GB RAM, 64GB internal storage, Android 9 Pie, Qualcomm Snapdragon 845, 3300 mAh battery, wireless charging, and IP68 dust and water resistance. The Xperia XZ3 has a gorgeous curved design with lovely color options and microSD storage expansion options. The 6-inch OLED screen looks great, especially when viewing video content and experiencing the HDR up-conversion technology.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 9,
  title: "LG V40 ThinQ",
  img: "img/product-8.png",
  price: 949.99,
  company: "LG",
  info:
    "LG continues to release great phones that appreciate over time and in a crowded flagship market, the LG V40 may have a tough time finding its place as well. While Huawei was one of the first major brands to launch a phone with three rear cameras, LG bumped that up by announcing a phone with five total cameras. Three are found on the back and two are on the front. LG has always stood apart from the others with its second rear camera having a true wide-angle lens for great landscape and large room photography. The new LG V40 keeps the wide-angle camera while also adding a telephoto lens to the standard lens option so you can do just about anything you want.",
  inCart: false,
  count: 0,
  total: 0
};
